/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Box } from '@atlaskit/primitives/compiled';
import { token, useThemeObserver } from '@atlaskit/tokens';

import appTilesDark from '../../../assets/app-tiles.dark.png';
import appTilesLight from '../../../assets/app-tiles.light.png';
import normalizeSeatBackgroundDark from '../../../assets/normalizeSeatBackground.dark.png';
import normalizeSeatBackgroundLight from '../../../assets/normalizeSeatBackground.light.png';
import { normalizeSeatModalMessages } from '../messages';

const styles = cssMap({
	container: {
		display: 'none',
		'@media (min-width: 64rem)': {
			height: '100%',
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
			position: 'relative',
			borderTopRightRadius: token('radius.small'),
			borderBottomRightRadius: token('radius.small'),
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			paddingTop: token('space.400'),
			paddingRight: token('space.400'),
			paddingBottom: token('space.400'),
			paddingLeft: token('space.400'),
			width: '50%',
		},
	},
});

export const ProductGraphic: () => JSX.Element = (): JSX.Element => {
	const { colorMode } = useThemeObserver();
	const { formatMessage } = useIntl();
	const isDarkMode = colorMode === 'dark';
	const backgroundImage = isDarkMode ? normalizeSeatBackgroundDark : normalizeSeatBackgroundLight;

	return (
		<Box xcss={styles.container} style={{ backgroundImage: `url(${backgroundImage})` }}>
			<Image
				src={isDarkMode ? appTilesDark : appTilesLight}
				srcDark={appTilesDark}
				alt={formatMessage(normalizeSeatModalMessages.appTilesAlt)}
				testId="app-tiles"
			/>
		</Box>
	);
};
